import { render, staticRenderFns } from "./OrderStatusMultiSelect.vue?vue&type=template&id=61bfc2d6&scoped=true"
import script from "./OrderStatusMultiSelect.vue?vue&type=script&lang=js"
export * from "./OrderStatusMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./OrderStatusMultiSelect.vue?vue&type=style&index=0&id=61bfc2d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bfc2d6",
  null
  
)

export default component.exports